import { render } from "./OFeerSection.vue?vue&type=template&id=10c1a1d2&scoped=true"
import script from "./OFeerSection.vue?vue&type=script&lang=js"
export * from "./OFeerSection.vue?vue&type=script&lang=js"

import "./OFeerSection.vue?vue&type=style&index=0&id=10c1a1d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c1a1d2"]])

export default __exports__